module.exports = __webpack_public_path__ + "img/security-audit.9f1b98e1.webp";